import React from 'react';
import PropTypes from 'prop-types';
import ConnectedTBReport from './ConnectedTBReport';

const TBReportRouting = ({ match }) => <ConnectedTBReport />;

TBReportRouting.propTypes = {
  match: PropTypes.shape({}),
};

export default TBReportRouting;
